// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__U1GS_","loading":"Pagination_loading__r80vA"};